module.exports = "/assets/data/89faf4545103387deee7291cb9a2eb93-SN7.data.json";